import './resources.scss';

import React from 'react';
import { Terms, Shipping, Faq, WildlifeResources, SkinPrep, Links } from './resources.data';

export function WildLife() {
    let rowCounter = 0;
    return (
        <div>
            <div id="wildlife-law-resources" className="anchor" />
            <h2>Wildlife Law Resources</h2>
            <div className="resources-wildlife-link">
                {WildlifeResources.map(i => {
                    return (
                        <div key={(rowCounter += 1)}>
                            <span>{i.name}</span>
                            <a href={i.url} target="_blank" rel="noopener noreferrer">
                                {i.url}
                            </a>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}

export default function Resources() {
    return (
        <>
            <h1 className="double resources-title">Resources</h1>
            <SkinPrep />
            <Shipping />
            <hr className="double" />
            <Terms />
            <Faq />
            <hr className="double" />
            <WildLife />
            <Links />
        </>
    );
}
